import { Predicates } from "../libraries/predicates/predicates";
import { IMold, INonMold } from "../types/data.interface";

export const formatMoldIntoOption = (item: IMold | null) => {
  return Predicates.isNotNullAndNotUndefined(item)
    ? {
        value: item,
        label: `${item.id} - ${item.name}`,
      }
    : null;
};

export const formatNonMoldIntoOption = (item: INonMold | null) => {
  return Predicates.isNotNullAndNotUndefined(item)
    ? {
      value: item,
      label: `${item.sequence_number} - ${item.name}`,
    }
    : null;
};

export const getMolds = (molds: IMold[]) =>
  molds.map(formatMoldIntoOption).filter(Predicates.isNotNullAndNotUndefined);

export const getNonMolds = (molds: INonMold[]) =>
  molds.map(formatNonMoldIntoOption).filter(Predicates.isNotNullAndNotUndefined);
